// extracted by mini-css-extract-plugin
module.exports = {"module":"textarea_module__1QftZ","label":"textarea_label__1htCK","textarea":"textarea_textarea__2AOQQ"};